"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntryCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const log_context_1 = require("../../context/log-context");
const log_1 = require("../../model/log");
exports.EntryCard = (0, react_1.memo)(({ title, description, icon, onClick, background, eventName, }) => {
    const theme = (0, material_1.useTheme)();
    const { logEvent } = (0, log_context_1.useLog)();
    const handleClick = (0, react_1.useCallback)(() => {
        if (eventName) {
            logEvent(log_1.LogEventType.Click, eventName);
        }
        onClick();
    }, [eventName, logEvent, onClick]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", width: theme.spacing(40), height: theme.spacing(30), sx: {
            background: background || theme.palette.gradient.card1,
            borderRadius: theme.spacing(2),
            transition: "transform 0.3s ease-in-out",
            "&:hover": {
                transform: "scale(1.05)",
            },
        }, spacing: 3, onClick: handleClick, paddingY: theme.spacing(6), padding: theme.spacing(3), children: [(0, jsx_runtime_1.jsx)(material_1.SvgIcon, { component: icon, sx: {
                    fontSize: theme.spacing(10),
                } }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", spacing: 1, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h4", noWrap: true, color: "primary.contrastText", fontWeight: theme.typography.fontWeightBold, children: title }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", color: "primary.contrastText", sx: {
                            "--web-line-clamp": "2",
                        }, children: description })] })] }));
});
exports.EntryCard.displayName = "EntryCard";
